import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-membersnewsedit',
  templateUrl: './members-news-edit.component.html',
  styleUrls: ['./members-news-edit.component.css']
})
export class MembersNewsEditComponent implements OnInit {

  ngOnInit() { }
}
